import axios from 'axios';

export default axios.create({
  baseURL: process.env.VUE_APP_AXIOS_URI,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('userToken')}`,
  },
});
